import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"
import InfoIcon from "../../../InfoIcon"
import { faDeleteLeft, faTrash } from "@fortawesome/free-solid-svg-icons"
import Filter from "./desktop/filter"
import Resort from "./desktop/resort"
import Backdrop from "../../../Backdrop"
import { Link, useNavigate } from "react-router-dom"
import useFetch from '../../../../hook/useFetch';
import { notificationActions } from "../../../../store/notification-slice"

export default function DesktopComponent() {

    const [desktopitems, setDesktopitems] = useState()

    let statelogs = useSelector(state => state.log.logs)

    let filteredlogs = useSelector((state) => state.log.filteredlogs)
    let user = useSelector(state => state.user.user)

    useEffect(() => {

        let items = []
        let logs = filteredlogs ?? statelogs

        if (logs && Object.keys(logs).length > 0) {

            logs.forEach((log) => {

                items.push(<DesktopItem key={log.id} log={log} user={user} />)

            })
        }
        setDesktopitems(items)

        
    }, [filteredlogs, statelogs])

    if (!desktopitems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <div className="table-responsive dashboard-data-table-scroll dashboard-data-table-scroll--compact">
            <table className="table table-striped table-bordered dashboard-data-table" >
                <thead>
                    <tr>

                        <th>ID <Resort type='id' /></th>
                        <th>Method <Resort type='method' /></th>
                        <th>Email <Resort type='email' /></th>
                        <th>CreatedOn <Resort type='created_on' /></th>

                        <th className="table-actions">Actions</th>


                    </tr>
                </thead>
                <tbody>
                    {desktopitems}
                </tbody>
            </table>
            </div>
        </Filter>
        <Backdrop />

    </Fragment>
}

function DesktopItem(props) {
    const { log ,user} = props
    
    let link = user.id === log.user_id ? '/admin/profile' : `/admin/users/${log.user_id}`
    
    const { del } = useFetch()

    let dispatch = useDispatch()

    let navigate = useNavigate()

    return <Fragment>

        <tr>

            <td>
                {log.id}
            </td>
            <td>
                {log.method}
            </td>
            <td>
                <Link to={link} >{log.email}</Link>
            </td>
            <td>
                {log.created_on}
            </td>
            <td className="table-actions">
                <button type="button" className="btn btn-warning" onClick={() => {
                    del(`/admin/log`, {id:log.id}, (data) => {
                        dispatch(notificationActions.setNotification({
                            message: data,
                            status: false
                        }))
                    },
                        () => {
                            dispatch(notificationActions.setNotification({
                                message: `log deleted`,
                                status: true
                            }))


                            navigate('/admin/logs', {
                                state: {
                                    refetch: true
                                }
                            })
                        }
                    )
                }} ><InfoIcon icon={faTrash} title='delete log' /></button>
            </td>


        </tr>

    </Fragment>

}
